import { Component } from '@angular/core';
import { GlobalService } from 'app/core/services/global/global.service';

@Component({
  selector: 'app-main-layuot',
  templateUrl: './main-layuot.component.html',
  styleUrls: ['./main-layuot.component.css']
})
export class MainLayuotComponent {

  constructor(public _global: GlobalService) {}
}
